import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import CustomTable from "../../components/universal/CustomTable";
import { toast } from "react-toastify";
import { AllPrayersHooks } from "./hooks/PrayerHooks";

const allPrayersHeader = [
  { headerName: "Subject", headerId: "subject", width: "w-48" },
  { headerName: "Prayer Request", headerId: "prayer_request", width: "w-72" },
];

function AllPrayers({ church }) {
  const location = useLocation();
  const { fetchPrayers } = AllPrayersHooks();
  const [reloadData, setReloadData] = useState(false);

  /* ----------------------------------------
     1️⃣ Detect entity type from URL
  ---------------------------------------- */
  const entityType = useMemo(() => {
    if (location.pathname.includes("addMinistryField")) return "ministry";
    if (location.pathname.includes("addChannelField")) return "channel";
    return "church";
  }, [location.pathname]);

  /* ----------------------------------------
     2️⃣ Helpers
  ---------------------------------------- */
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const transformTableData = (data) =>
    data.map((prayer) => ({
      ...prayer,
      prayerObjId: prayer._id,
      subject: prayer.subject || "N/A",
      prayer_request: prayer.prayer_request || "N/A",
      userName: `${prayer.user?.firstName || ""} ${
        prayer.user?.lastName || ""
      }`.trim(),
      createdDate: prayer.createdDate
        ? formatDate(prayer.createdDate)
        : "N/A",
    }));

  /* ----------------------------------------
     3️⃣ Render
  ---------------------------------------- */
  return (
    <div className="App bg-[#191919] min-h-screen p-4">
      <CustomTable
        searchFor="Prayers"
        heightDesktop="h-[68vh]"
        width="w-full"
        headers={allPrayersHeader}
        data={[]}
        customDataFetch={true}
        customDataFetchFunction={(page, limit, searchCriteria, callback) =>
          fetchPrayers(
            page,
            limit,
            searchCriteria,
            callback,
            entityType,      // ✅ church | ministry | channel
            church?._id      // ✅ entity ID
          )
        }
        dataTransformer={transformTableData}
        reloadData={reloadData}
        setReloadData={setReloadData}
        showSearch={true}
        searchPlaceholder="Search by subject, prayer or user..."

        showViewDetails={true}
        showEdit={false}
        showDelete={false}
        handleViewDetailsClick={(row) => {
          toast.info(`Viewing prayer: ${row.prayer_request}`, {
            autoClose: 2000,
          });
        }}

        handleEditClick={() => {}}
        handleDeleteClick={() => {}}
        emptyStateMessage="No prayer requests found."
      />
    </div>
  );
}

export default AllPrayers;
